<template>
    <div v-if="widgetReady">
        <h4>
            {{vm.name}}<template v-if="vm.designation">,</template> {{vm.designation}}
        </h4>
        <dl>
            <dt>Education</dt>
            <dd>
                Medical School:
                <span v-if="vm.physicianEducation.medicalSchool">
                    {{vm.physicianEducation.medicalSchool}}
                </span>
                <span v-else>
                    None found
                </span>
            </dd>
            <dd>
                Residency:
                <span v-if="vm.physicianEducation.residency">
                    {{vm.physicianEducation.residency}}
                </span>
                <span v-else>
                    None found
                </span>
            </dd>
            <dt>Languages Spoken</dt>
            <dd v-for="sl in vm.spokenLanguages">
                {{sl}}
            </dd>
            <dd v-if="vm.spokenLanguages.length==0">English</dd>
            <template v-if="vm.physicianEducation.boardCertifications">
                <dt>Board Certifications</dt>
                <dd>
                    <span>{{vm.physicianEducation.boardCertifications}}</span>
                </dd>
            </template>
            <template v-if="vm.specialties.length > 0">
                <dt>
                    Specialties
                </dt>
                <dd v-for="sp in vm.specialties">
                    {{sp}}
                </dd>
            </template>
        </dl>
        <dl v-if="showOffice && vm.features.length>0">
            <dt>Office Features</dt>
            <dd v-for="ft in features">
                {{ft}}
            </dd>
        </dl>
        <div v-if="showBio" class="row summernote-override">
            <div class="col-lg-12" v-html="vm.biography"></div>
        </div>
    </div>
</template>

<script>
    import {common} from "../../../global/common.js";

    export default {
        name: "PhysicianInfo",
        props: {
            providerEntityId: {type: [Number], required: true},
            showOffice: {type: [Boolean], default: true},
            showBio: {type: [Boolean], default: true},
        },
        data() {
            return {
                vm: {},
                widgetReady: false
            }
        },
        async mounted() {
            let data = await $.ajax({type: "Get", url: `Shared/getProviderDetailsAndBio/${this.providerEntityId}`});
            this.mapData('vm', data);
            this.vm.designation = common.filterProfDesignations(this.vm.designation);
            this.widgetReady = true;
        }
    }
</script>

<style scoped>

</style>